import React from 'react';
import PropTypes from 'prop-types';
import VirtualList from 'react-tiny-virtual-list';
import { WindowScroller } from 'react-virtualized';
import ServicesTableRow from './Row';
import { getHeightRow } from '../../../../../Services/Main/helpers/getters';

const ServicesTableBody = ({ data, filters }) => {
  const itemSize = data.length;

  return (
    <WindowScroller>
      {({ height }) => (
        <VirtualList
          width="100%"
          className="reports-services-table__container"
          height={height - 258}
          itemCount={itemSize}
          itemSize={(index) => getHeightRow(data[index])}
          renderItem={({ index, style }) => {
            const service = data[index];
            return (
              <ServicesTableRow
                key={index}
                index={index}
                style={style}
                query={filters?.query}
                query_type={filters?.query_type}
                service={service}
              />
            )
          }}
        />
      )}
    </WindowScroller>
  )
};

ServicesTableBody.propTypes = {
  data: PropTypes.array.isRequired,
  filters: PropTypes.object,
};

export default ServicesTableBody;
